import "../../styles/components/common/inputElementComponent.css";

export const InputElementComponent = ({ inputElementProps }) => {
  const { type, name, id, value, onChange, placeholder, label, error, required, disabled, className, style, removeDefaultStyle, checked } = inputElementProps;

  return (
    <div className={`${removeDefaultStyle ? "" : "inputContainer"} ${className}`} style={style}>
      {label && (
        <label htmlFor={name}>
          {label} {error && <span className="errorMessage">{error}</span>}
        </label>
      )}
      <input type={type} name={name} id={id ? id : name} value={value} onChange={onChange} placeholder={placeholder} required={required} disabled={disabled} checked={checked} />
    </div>
  );
};

export default InputElementComponent;
